export default {
  locale: (state) => state.locale,
  formatLocale: (state) => state.formatLocale,
  availableTranslations: (state) => state.availableTranslations,
};
